import { AUTHENTICATE, LOG_OUT } from "../actions/auth";

const initialState = {
    token: null,
    userId: null,
    refreshTokenId: null,
    firstOpen: true
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATE:
            return {
                token: action.token,
                userId: action.userId,
                refreshTokenId: action.refreshTokenId
            };
        case LOG_OUT:
            return { ...initialState };
        default:
            return state;
    }
};

export default authReducer;